module.exports = __webpack_public_path__ + "img/Body Shaping Treatment 4.c6371ae6.jpg";